module.exports = __webpack_public_path__ + "static/media/PG_Logo_light.1a2f1cab.svg";